export default "__VITE_ASSET__BlX8hQq___"